var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 68"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.718 1.812a6.06 6.06 0 0 1 8.59-.054l12.233 12.094.018.018 13.683 13.97A6.17 6.17 0 0 1 64 32.156v29.7C64 65.25 61.271 68 57.905 68H6.095C2.73 68 0 65.25 0 61.856V32.19c0-1.642.653-3.216 1.812-4.37l14.02-13.959z",
    clipRule: "evenodd"
  })));
};
export default SvgHouse;